(() => {
  const search = window.KeysrusSearch;
  const region = document.querySelector('[data-keysrus-search-results]');
  const status = document.querySelector('[data-keysrus-search-status]');
  if (!search || !region || !status) return;
  let revision = 0;
  let controller;
  const initial = new URLSearchParams(location.search);

  function showGuidance(intent, options) {
    region.querySelector(':scope > .keysrus-search-guidance')?.remove();
    const help = search.guidance(intent, options);
    if (help.childElementCount) { help.classList.add('page-width'); region.prepend(help); }
  }

  function finishLoading() {
    region.classList.remove('keysrus-search-results--loading');
    region.removeAttribute('aria-busy');
  }

  // The server-rendered native results stay visible while an interpreted query loads. The first
  // interpreted request keeps those native results when it finds nothing or cannot load.
  async function render(parameters, updateHistory = false, event, options = {}) {
    const params = new URLSearchParams(parameters);
    const intent = search.plan(params.get('q'), params.get('kr_raw') === '1');
    const current = ++revision;
    controller?.abort();
    controller = new AbortController();
    const activeController = controller;
    const signal = activeController.signal;
    const timeout = setTimeout(() => activeController.abort(), 12000);
    const focusedId = event?.target?.id;
    const openDetails = [...region.querySelectorAll('details[open][id]')].map(element => element.id);
    region.closest('infinite-scroll')?.destroy?.();
    status.hidden = true;
    region.hidden = false;
    region.classList.add('keysrus-search-results--loading');
    region.setAttribute('aria-busy', 'true');
    if (updateHistory) history.pushState({ searchParams: params.toString() }, '', `${location.pathname}?${params}`);
    try {
      const url = new URL(`${location.pathname}?${params}`, location.origin);
      url.searchParams.set('section_id', region.dataset.section);
      const response = await fetch(search.requestURL(url), { signal });
      if (!response.ok) throw Error('Search unavailable');
      const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = documentResult.querySelector('[data-keysrus-search-results]');
      if (!result) throw Error('Search response missing');
      if (current !== revision) return;
      if (options.keepNative && intent.kind !== 'native' && result.dataset.resultCount === '0') {
        search.preferNative(params.get('q'));
        finishLoading();
        region.closest('infinite-scroll')?.init?.();
        return;
      }
      search.humanize(result, intent);
      region.innerHTML = result.innerHTML;
      region.closest('.template-search')?.classList.toggle('template-search--empty', result.dataset.resultCount === '0');
      showGuidance(intent, { escape: true });
      region.querySelectorAll('.scroll-trigger').forEach(element => element.classList.add('scroll-trigger--cancel'));
      openDetails.forEach(id => { const element = document.getElementById(id); if (element && region.contains(element)) element.open = true; });
      window.renderSelects?.();
      window.loadDesktopOnlyTemplates?.();
      window.stickersReinit?.();
      region.closest('infinite-scroll')?.init?.();
      if (focusedId) document.getElementById(focusedId)?.focus({ preventScroll: true });
      if (current !== revision) return;
      region.dataset.query = intent.original;
    } catch {
      if (current !== revision) return;
      if (options.keepNative) {
        region.closest('infinite-scroll')?.init?.();
        return;
      }
      region.replaceChildren();
      region.hidden = true;
      const message = document.createElement('p');
      message.textContent = search.copy.results_unavailable;
      const retry = document.createElement('button');
      retry.type = 'button'; retry.className = 'button button--secondary'; retry.textContent = search.copy.retry;
      retry.addEventListener('click', () => render(parameters));
      status.replaceChildren(message, retry);
      status.hidden = false;
    } finally {
      clearTimeout(timeout);
      if (current === revision) finishLoading();
    }
  }

  window.KeysrusSearchResults = { render };
  const intent = search.plan(initial.get('q'), initial.get('kr_raw') === '1');
  if (intent.kind !== 'native') render(initial, false, undefined, { keepNative: true });
  else showGuidance(intent);
})();
